import type { QueryClient } from '@tanstack/react-query';

/**
 * Re-fetch everything on a vendor's detail page after a write: the company,
 * its submissions list, comment threads, file histories, pending changes and
 * activity all live under ['company', companyId].
 *
 * Invalidate ONLY this prefix. Invalidating a narrower key first and then the
 * prefix starts the narrower query's fetch twice (the second cancels the
 * first, but adminApi ignores the abort signal, so both requests reach the
 * API) — and the submissions list alone takes ~2 s.
 */
export function invalidateCompany(qc: QueryClient, companyId: string): void {
  void qc.invalidateQueries({ queryKey: ['company', companyId] });
}
